import { Car, User, Star, DollarSign } from 'lucide-react';

export type DriverTab = 'drive' | 'account' | 'ratings' | 'earnings';

interface DriverBottomNavProps {
  active: DriverTab;
  onChange: (tab: DriverTab) => void;
}

const items: { key: DriverTab; label: string; icon: any }[] = [
  { key: 'drive', label: 'Drive', icon: Car },
  { key: 'account', label: 'Account', icon: User },
  { key: 'ratings', label: 'Ratings', icon: Star },
  { key: 'earnings', label: 'Earnings', icon: DollarSign },
];

const DriverBottomNav = ({ active, onChange }: DriverBottomNavProps) => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-[1500] bg-white border-t border-gray-200 px-2 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
      <div className="flex justify-around">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = active === item.key;
          return (
            <button
              key={item.key}
              onClick={() => onChange(item.key)}
              className={`flex flex-col items-center gap-1 px-4 py-1.5 rounded-lg transition-colors ${
                isActive ? 'text-red-600' : 'text-gray-500 hover:text-red-600'
              }`}
            >
              <Icon className={`h-6 w-6 ${isActive ? 'fill-red-600/10' : ''}`} />
              <span className="text-[11px] font-semibold">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default DriverBottomNav;
